import Phaser from "phaser";
import * as rexInputText from "./plugins/rexinputtextplugin.min";
import SaveCPUPlugin from "./plugins/SaveCPU";

import BootScene from "./scenes/BootScene";
import PreloadScene from "./scenes/PreloadScene";
import GameScene from "./scenes/GameScene";
import { DeviceDetection } from "./helpers/deviceDetection";

const width = window.devicePixelRatio * window.innerWidth;
const height = window.devicePixelRatio * window.innerHeight;
const config = {
  type: Phaser.CANVAS,
  scale: {
    parent: "game",
    // mode: Phaser.Scale.RESIZE,
    mode: Phaser.Scale.FIT,
    // autoCenter: Phaser.Scale.CENTER_BOTH,
    width: width,
    // width: '100%',
    // height: '100%'
    height: height,
  },
  backgroundColor: 0x202530,
  title: "TREYS",
  url: "https://treyspoker.com/",
  version: "1.55.2",
  dom: {
    createContainer: true,
  },
  scene: [BootScene, PreloadScene, GameScene],
  plugins: {
    global: [
      {
        key: "rexInputText",
        plugin: rexInputText,
        start: true,
      },
      {
        key: "SaveCPUPlugin",
        plugin: SaveCPUPlugin,
        start: true,
      },
    ],
    // scene: [{
    //   key: 'rexUI',
    //   plugin: UIPlugin,
    //   mapping: 'rexUI',
    // }]
  },
};
function launch(containerId) {
  config.scale.parent = containerId;
  if (DeviceDetection.isiPhone()) {
    config.fps = {
      target: 52,
      forceSetTimeOut: true,
    };
  }
  return new Phaser.Game(config);
}

export default launch;
export { launch };
